import { mount} from 'redom';
import FilterController from './FilterController';
import ChannelController from './ChannelController';
import EventController from './EventController';
import ChannelList from './ChannelList';
import ScheduleList from './ScheduleList';
import Container from './../lib/gui/dom/Container';
import KeyInterceptor from './KeyInterceptor';
import EventManager from './EventManager';
import TimeBarController from './TimeBarController';
import Utils from '../../utils/Utils';
import {
  AAF_CONTENT_IS_CATCHUP,
} from '../../AAFPlayer/constants';

let controllers;
let eventManagerController;

const setOnClickEventCallback = function(cbk) {
  controllers.eventController.setOnClickEventCallback(cbk);
};

const setOnRecEventCallback = function(cbk) {
  controllers.eventController.setOnRecEventCallback(cbk);
};

const redrawGrid = function(gids) {
  let _gids = gids && Array.isArray(gids) && gids.length>0 && gids.map((ungid) => {
    return ungid.group_id;
  });
  if(_gids && Array.isArray(_gids) && _gids.length>0){
    controllers && controllers.eventController.drawGrid(_gids);
  }
};

const setLoading = function(opacity) {
  controllers.eventController.setLoading(opacity);
};

const getMaxTime = function (maxTime) {
  return controllers.eventController.getLatestRightEventTime();
};

const getMinTime = function (minTime) {
  return controllers.eventController.getLatestLeftEventTime();
};

const setIsDrawing = function (minTime) {
  return controllers.eventController.isGridDrawing();
};

const setYellowButton = function(callback){
  controllers.filterController.setYellow(callback);
};

const setRefChannel = function(callback){
  controllers.channelController.setRefChannel(callback);
};

/**
 *
 * @param {*} startTime
 * @param {*} endTime
 *
 * Aquí entra en modo desesperado, gobernado por schedulelist
 */
const redrawGridTimeBar = function (startTime, endTime, keyDirection) {
  // Actualizo el starTime
  controllers.eventController.setStartTime(startTime);
  controllers.eventController.drawGrid(controllers.eventController.getCurrentGroupdIds(), null, null, keyDirection);
};

const getStartTime = (extraparams) =>{
  let current = Utils.nowAsTimestampSeconds();
  if(extraparams && (typeof extraparams.getCurrentEvent === 'function') && (typeof extraparams.getContenStreamType === 'function')){
    const contentType = extraparams.getContenStreamType();
    const currentEvent = extraparams.getCurrentEvent();
    if(currentEvent && currentEvent.date_begin){
      switch(contentType){
        case AAF_CONTENT_IS_CATCHUP:
          current = currentEvent.date_begin;
          break;
        default:
      }
    }
  }
  return current;
}


/**
 *
 * @param {*} fullEpgContainerId string div id donde se montará la full epg
 */
const initialise = async function (fullEpgContainerId, extraparams = {}) {
  let channelList = new ChannelList();
  const filterControl = await new FilterController(channelList);
  /** CALCULANDO A PARTIR DE QUE TIEMPO INICIA LA EPG, EN BASE A STREAMCONTENTYPE Y EVENTO**/
  const startTime = getStartTime(extraparams);

  let scheduleList = new ScheduleList(startTime);
  controllers = {
    //Controlador para filtros
    filterController: filterControl,
    //Controlador para canales
    channelController: new ChannelController(channelList),
    // Controlador para eventos, timeline
    eventController: new EventController(channelList, scheduleList,startTime, extraparams),
    timeBarController: new TimeBarController(scheduleList)
  };
  controllers.channelController.setRedrawGridCallback(redrawGrid);
  controllers.channelController.setLoadingCallback(setLoading);
  controllers.timeBarController.setRedrawGridCallback(redrawGridTimeBar);
  controllers.timeBarController.setLoadingCallback(setLoading);
  controllers.timeBarController.getMaxTimeCallback(getMaxTime);
  controllers.timeBarController.getMinTimeCallback(getMinTime);
  controllers.timeBarController.setIsDrawing(setIsDrawing);


  eventManagerController = new EventManager(controllers);
  // KeyInterceptor.init();
  // KeyInterceptor.registerInterceptor(eventManagerController.keyHandler, eventManagerController);

  // Mount full EPG component
  const fullEpgComponent_id = 'fullEpgComponent';
  const fullEpgComponent = new Container(null, { id: fullEpgComponent_id});
  mount(document.getElementById(fullEpgContainerId), fullEpgComponent.getRootElement());

  // controllers.filterController.initialise(fullEpgComponent);
  controllers.channelController.initialise(fullEpgComponent);
  controllers.eventController.initialise(fullEpgComponent);
  controllers.timeBarController.initialise(fullEpgComponent);

  //const ids=[762273, 762234, 774043, 774042, 772139];
  //controllers.eventController.drawGrid(ids);
};

const disableInterceptor = function () {
  KeyInterceptor.destroy();
};

const enableInterceptor= function () {
  KeyInterceptor.init();
  KeyInterceptor.registerInterceptor(eventManagerController.keyHandler, eventManagerController);
};

const activate = function (loadObject={}, init= false) {
  controllers.filterController.activate(loadObject, init);
};

const setOutside = function (callback) {
  eventManagerController.setOutside(callback);
};
const setHandleMosaic =  function (callback) {
  eventManagerController.setHandleMosaic(callback);
};

const setHandleGuide =  function (callback) {
  eventManagerController.setHandleGuide(callback);
};

const setHandleRed = function (callback) {
  eventManagerController.setHandleRed(callback);
};

const setBlueButton = function(callback){
  eventManagerController.setHandleBlue(callback);
};

const setClearTimeoutAutoHide =  function (callback) {
  eventManagerController.setClearTimeoutAutoHide(callback);
};

const setAutoHideTimeout =  function (callback) {
  eventManagerController.setAutoHideTimeout(callback);
};

/**
 * FIXME. Cuando se desmonte la EPG, poner en standby todo lo que se tenga que poner en stand by aquí
 */
const deactivate = function() {
  controllers.eventController.deactivate();
  KeyInterceptor.destroy();
  controllers = null;
  eventManagerController = null;
};

const EpgController = {
  initialise,
  activate,
  deactivate,
  enableInterceptor,
  disableInterceptor,
  redrawGrid,
  setYellowButton,
  setBlueButton,
  setHandleRed,
  setRefChannel,
  setOnClickEventCallback,
  setOnRecEventCallback,
  setOutside,
  setHandleMosaic,
  setHandleGuide,
  setClearTimeoutAutoHide,
  setAutoHideTimeout
};

export default EpgController;



// WEBPACK FOOTER //
// ./src/AAF/Nepg/EpgController.js